import { render, staticRenderFns } from "./button.html?vue&type=template&id=2ea0995f&scoped=true&external"
import script from "./button.js?vue&type=script&lang=js&external"
export * from "./button.js?vue&type=script&lang=js&external"
import style0 from "./button.scss?vue&type=style&index=0&id=2ea0995f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea0995f",
  null
  
)

export default component.exports